import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SkillCreationSliderComponent } from './components/skill-creation-slider/skill-creation-slider.component';
import { SkillLibraryComponent } from './skill-library/skill-library.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SkillPersistenceService } from './services/skill-persistence.service';
import { SharedModule } from '../shared/shared.module';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { BptDateTimeModule } from 'bpt-ui-library/bpt-datetime';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { BptNumericInputModule } from 'bpt-ui-library/bpt-numeric-input';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TreeSelectModule } from 'primeng/treeselect';
import { TooltipModule } from 'primeng/tooltip';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { LabelComponent } from '../shared-components/label/label.component';
import { BptFileUploadModule } from 'bpt-ui-library/bpt-file-upload';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { PanelModule } from 'primeng/panel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { BadgeModule } from 'primeng/badge';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { DividerModule } from 'primeng/divider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SkillRoutingModule } from './skill-routing.module';
import { SkillDetailsComponent } from './components/skill-details/skill-details.component';
import { SkillTrainingItemSliderComponent } from './components/skill-details/skill-training-item-slider/skill-training-item-slider.component';
import { SkillDocumentDetailsComponent } from './components/skill-details/skill-training-item-slider/skill-document-details/skill-document-details.component';
import { SkillCourseDetailsComponent } from './components/skill-details/skill-training-item-slider/skill-course-details/skill-course-details.component';
import { SkillTrainingItemGroupDetailsComponent } from './components/skill-details/skill-training-item-slider/skill-training-item-group-details/skill-training-item-group-details.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { DocumentSearchModule } from '../document-search/document-search.module';
import { CourseCatalogueModule } from '../course-catalogue/course-catalogue.module';
import { TrainingItemGroupSearchModule } from '../training-item-group-search/training-item-group-search.module';
import { SkillTrainingItemsListComponent } from './components/skill-training-items-list/skill-training-items-list.component';
import { SkillAuditTrialComponent } from './components/skill-audit-trial/skill-audit-trial.component';
import { SkillAuditSummaryComponent } from './components/skill-audit-summary/skill-audit-summary.component';
import { SkillSearchModule } from '../skill-search/skill-search.module';
import { PanelHubComponent } from '../shared-components/panel-hub/panel-hub.component';



@NgModule({
  declarations: [
    SkillCreationSliderComponent,
    SkillDetailsComponent,
    SkillTrainingItemSliderComponent,
    SkillDocumentDetailsComponent,
    SkillCourseDetailsComponent,
    SkillTrainingItemGroupDetailsComponent,
    SkillLibraryComponent,
    SkillTrainingItemsListComponent,
    SkillAuditTrialComponent,
    SkillAuditSummaryComponent
  ],
  providers: [ConfirmationService, MessageService, DatePipe, SkillPersistenceService],
  imports: [
      CommonModule,
      SkillRoutingModule,
      SharedModule,
      BptTextInputModule,
      BptNumericInputModule,
      BptDateTimeModule,
      BptDropdownModule,
      TabViewModule,
      ButtonModule,
      TabMenuModule,
      FieldsetModule,
      DividerModule,
      RadioButtonModule,
      BadgeModule,
      ScrollPanelModule,
      PanelModule,
      MessageModule,
      MessagesModule,
      DialogModule,
      FormsModule,
      RouterModule,
      ReactiveFormsModule,
      ConfirmDialogModule,
      ToastModule,
      CalendarModule,
      BptProgressSpinnerModule,
      CheckboxModule, 
      TooltipModule,
      BptFileUploadModule,
      SelectButtonModule,
      TreeSelectModule,
      EmptyResultsComponent,
      SpinnerComponent,
      LabelComponent,
      PanelHubComponent,
      SplitButtonModule,
      DocumentSearchModule,
      CourseCatalogueModule,
      TrainingItemGroupSearchModule,
      SkillSearchModule
    ]
})
export class SkillModule { }
